export default "__VITE_ASSET__CxXNhLpH__"